import React from "react";

const DivHtml = ({ children, ...otherProps }) => {
  const createMarkup = htmlString => ({ __html: htmlString });
  return <div {...otherProps} dangerouslySetInnerHTML={createMarkup(children)} />;
};

export default DivHtml;
